import { Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import {
  TextArrayField,
  useGetList,
  useNotify,
  useRecordContext,
} from 'react-admin';
import InfoPopover from '../../layout/InfoPopover';
import SelectArrayInput from '../../layout/inputFields/SelectArrayInput';

const NotifyEmail = ({ disabled }: { disabled: boolean }) => {
  const notify = useNotify();
  const record = useRecordContext();
  const [emails, setEmails] = useState(new Set());

  const { data } = useGetList('members');

  useEffect(() => {
    const memberEmails = record?.notificationEmails ?? [];
    setEmails((prev) => new Set([...prev, ...memberEmails]));
  }, [record?.notificationEmails]);

  useEffect(() => {
    const memberEmails = data?.map((member) => member.email) ?? [];
    setEmails((prev) => new Set([...prev, ...memberEmails]));
  }, [data]);

  const handleCreate = useCallback(() => {
    // eslint-disable-next-line no-alert
    const newEmail = prompt('Enter a new email')?.toLowerCase();
    if (Array.from(emails).some((email) => email === newEmail)) {
      notify('Email already exist in list');
      return emails;
    }
    setEmails((prev) => new Set([...prev, newEmail]));
    return newEmail;
  }, [emails, notify]);

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography variant="label">
          Email for notifications
          <InfoPopover title="Email list for notifications" content="Used to send email notifications to the list of recipients when a ping is created." />
        </Typography>
      </Grid>
      <Grid size={12}>
        {disabled ? (
          <TextArrayField source="notificationEmails" emptyText="-" />
        ) : (
          <SelectArrayInput
            fullWidth
            onCreate={handleCreate}
            source="notificationEmails"
            label="Email recipients"
            choices={Array.from(emails)?.map((email) => ({ id: email, name: email }))}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default NotifyEmail;
